import axios from 'axios'
import { Message } from 'view-design'
import router from '@/router'
import { showLoading, closeLoading } from '@/utils/loading'
import { resetTokenAndClearUser } from '@/utils'
import { API_BASE_URL } from '@/utils/api'

const service = axios.create({
    baseURL: API_BASE_URL,
    timeout: 60000,
})

service.interceptors.request.use(config => {
    // showLoading()
    return config
}, (error) => Promise.reject(error))

service.interceptors.response.use(response => {
    closeLoading()
    const res = response.data
    // 这里是接口处理的一个示范，可以根据自己的项目需求更改
    // 错误处理
    if (res.code == 0 && res.msg) {
        Message.error({
            content: res.msg,
        })
        return Promise.reject()
    }

    // 如果接口正常，直接返回数据
    return res
}, (error) => {
    closeLoading()
    Message.error({
        content: error.message || '系统异常，请联系管理员',
    })
    return Promise.reject(error)
})

export default service
